<template>
  <div>
    <template v-if="region_id">
      <h4 class="mb-2">
        {{ providerDetails.region_model_type === 1 ? t('Edit Region') : t('Edit Country') }}
      </h4>
    </template>
    <template v-else>
      <h4 class="mb-2">
        {{ providerDetails.region_model_type === 1 ? t('Add New Region') : t('Add New Country') }}
      </h4>
    </template>
    <b-overlay
      variant="white"
      :show="submitting"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <validation-observer ref="providerRegionDetailForm">
        <b-form ref="providerRegionDetailFormElement" class="" @submit.prevent="submit">
          <b-row>
            <b-col v-if="providerDetails.region_model_type === 1" md="6" lg="6">
              <b-form-group>
                <div class="d-flex form-group-label">
                  <label for="name">{{ t('Name') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <validation-provider #default="{ errors }" :name="t('Name')" rules="required">
                  <b-form-input
                    id="name"
                    v-model="values.name"
                    name="name"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="t('Name')"
                    tabindex="3"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col md="6" lg="6">
              <validation-provider
                #default="{ errors }"
                :name="t('Country')"
                rules="required"
                vid="consignor_country"
              >
                <b-form-group
                  :label="t('Country')"
                  label-for="consignor_country"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    v-if="Object.keys(providerDetails).length > 0"
                    id="consignor_country"
                    v-model="values.countries"
                    :options="countries"
                    :placeholder="t('Make a Choice')"
                    label="text"
                    :multiple="providerDetails.region_model_type === 1"
                    @input="getConsignorStateList"
                  >
                    <span slot="no-options">{{ t('No records found') }}</span>
                  </v-select>
                  <b-form-invalid-feedback :state="errors.length > 0 ? false : null">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12">
              <b-button
                variant="primary"
                class="mt-1 d-flex align-items-center"
                type="submit"
                tabindex="11"
              >
                {{ submitting ? t('Please Wait') : type === 'new' ? t('Add') : t('Save') }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-overlay>
  </div>
</template>
<script>
import {
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BFormInvalidFeedback,
  BButton,
  BOverlay
} from 'bootstrap-vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { togglePasswordVisibility } from '@core/mixins/ui/forms';
import vSelect from 'vue-select';
import { mapGetters } from 'vuex';
import { helper } from '@core/mixins/helper';

export default {
  components: {
    BOverlay,
    BButton,
    BFormInvalidFeedback,
    vSelect,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BForm,

    ValidationObserver,
    ValidationProvider
  },

  mixins: [togglePasswordVisibility, helper],
  props: {
    type: {
      type: String,
      default: 'new'
    },
    submitting: {
      type: Boolean,
      default: false
    },
    values: {
      type: Object,
      default() {
        return {
          name: '',
          countries: []
        };
      }
    }
  },
  data() {
    return {
      statusTypeOptions: [],
      region_id: null
    };
  },

  computed: {
    ...mapGetters({
      countries: 'app/countries',
      providerDetails: 'app/providerDetails'
    })
  },
  async created() {
    await this.$store.dispatch('app/getCountries');

    if (
      Object.keys(this.providerDetails).length < 1 ||
      (Object.keys(this.providerDetails).length > 0 &&
        parseInt(this.providerDetails.id) !== parseInt(this.$route.params.id))
    ) {
      await this.$store.dispatch('app/getProviderDetails', this.$route.params.id);
    }
  },
  mounted() {
    if (this.$route.params.region_id) {
      this.region_id = this.$route.params.region_id;
    }

    this.statusTypeOptions = [
      { value: 1, text: '0' },
      { value: 0, text: '1' }
    ];
  },

  methods: {
    submit() {
      this.$refs.providerRegionDetailForm.validate().then(success => {
        if (success) {
          const requestData = {
            ...this.values
          };

          if (this.providerDetails.region_model_type === 2 && this.values.countries) {
            requestData.name = this.values.countries.text || '';
          }

          this.$emit('submit', requestData);
        }
      });
    },

    resetForm() {
      this.$refs.providerRegionDetailFormElement.reset();
    },

    getConsignorStateList(data) {
      if (data && data.value) {
        this.$store.dispatch('app/getConsignorStates', data.value);
      }
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
